import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Section } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import { scrollToSection } from 'utils/scrollTo';

import loadable from '@loadable/component';
const LargeTitleAndText = loadable(() =>
  import('components/components/molecules/LargeTitleAndText'),
);
const VideoGalleyVideo = loadable(() =>
  import('components/components/molecules/VideoGalleyVideo'),
);
const VideoGalleyMenu = loadable(() =>
  import('components/components/organisms/VideoGalleyMenu'),
);

const VideoGalleyContainerDiv = styled.div`
  padding-right: 0px;
  padding-left: 0px;
  width: 90%;
`;

const getVideoGallerySubcategories = (subcategories) => {
  if (subcategories && subcategories.length > 0) {
    for (let i = 0; i < subcategories.length; i++) {
      const scVideos = subcategories[i] && subcategories[i].videos;
      for (let j = 0; j < scVideos.length; j++) {
        const video = scVideos[j];
        const videoTitle = video && video.title && video.title.toLowerCase();
        if (typeof videoTitle !== 'undefined' && videoTitle.length > 0) {
          if (typeof videoTitle === 'string') {
            video.deepLink = videoTitle.replace(/\s/g, '-');
          } else {
            video.deepLink = String(videoTitle).replace(/\s/g, '-');
          }
          video.subCategoryTitle = subcategories[i] && subcategories[i].title;
        }
      }
    }
    return subcategories;
  }
  return [];
};

const isDeepLink = (text, categories) => {
  if (categories) {
    let video;
    for (let i = 0; i < categories.length; i++) {
      const scVideos = categories[i].videos;
      video = scVideos.filter((v) => v.deepLink === text);
      if (video.length === 1) {
        break;
      }
    }
    return video[0];
  }
  return null;
};

const VideoGalleryContainer = ({ fields }) => {
  const videoGallery = getFieldValue(fields, 'videoGallery') || {};
  const subcategories = getVideoGallerySubcategories(
    videoGallery && videoGallery.subcategories
      ? videoGallery.subcategories
      : [],
  );

  const location = useLocation();
  const hash = location.hash;
  const videoDeepLink =
    hash && hash.substring(1) && isDeepLink(hash.substring(1), subcategories);
  const hasDeepLink = videoDeepLink && videoDeepLink.title ? true : false;
  useEffect(() => {
    if (hasDeepLink) {
      setTimeout(() => {
        scrollToSection('VideoGallery', 80);
      }, 1500);
    }
  });

  const defaultvideoSelected = hasDeepLink
    ? videoDeepLink
    : subcategories &&
      subcategories.length > 0 &&
      subcategories[0] &&
      subcategories[0].videos &&
      subcategories[0].videos.length > 0 &&
      subcategories[0].videos[0];

  const defaultSubmenuOpen =
    defaultvideoSelected && defaultvideoSelected.subCategoryTitle;

  /* console.log({
    hasDeepLink,
    videoDeepLink,
    defaultvideoSelected,
    defaultSubmenuOpen,
  });*/

  const [videoSelected, setVideoSelected] = useState(defaultvideoSelected);
  const [submenuSelected, setSubmenuSelected] = useState(defaultSubmenuOpen);

  const handleSelectedVideo = (video) => {
    setVideoSelected(video);
    window.location.hash = video.deepLink;
  };
  const handleSelectedSubmenu = (menuItem, video) => {
    setSubmenuSelected(menuItem);
    // setVideoSelected(video);
    // window.location.hash = video.deepLink;
  };

  if (!(defaultvideoSelected && defaultvideoSelected.title)) return '';

  return (
    <Section id={'VideoGallery'}>
      <VideoGalleyContainerDiv>
        <div className='mb-6 md:mb-12'>
          <LargeTitleAndText
            title={videoGallery && videoGallery.title}
            text={videoGallery && videoGallery.copy}
            textAlignment={'left'}
          />
        </div>
        <div className='flex flex-col md:flex-row'>
          <div className='flex w-full md:w-3/12 bg-menu-video-galley'>
            <VideoGalleyMenu
              videoList={videoGallery && videoGallery.subcategories}
              onSelectedVideo={handleSelectedVideo}
              onSelectedSubmenu={handleSelectedSubmenu}
              videoSelected={videoSelected}
              submenuSelected={submenuSelected}
            />
          </div>
          <div className='flex w-full md:w-9/12 bg-white'>
            <VideoGalleyVideo videoSelected={videoSelected} />
          </div>
        </div>
      </VideoGalleyContainerDiv>
    </Section>
  );
};

export default VideoGalleryContainer;
